import React, { useState, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Autocomplete,
  Typography,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid2,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material';
import { toast } from 'sonner';
import { Iconify } from '../Minimal/src/components/iconify';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { TablePaginationCustom } from '../Minimal/src/components/pagination';
import { useTable } from '../Minimal/src/hooks/use-table';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import { format } from 'date-fns';
import { API_URL, BASE_URL } from '../Config';
import AccountService from '../../services/AccountServices';
import '../common/commonStyles.css';

const SupplierLedger = () => {
  const accessToken = localStorage.getItem('accessToken');
  const token = localStorage.getItem('token');
  const [dates, setDates] = useState([null, null]);
  const [reportrange, setReportrange] = useState('');
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [supplierValue, setSupplierValue] = useState(null);
  const [supplierLedger, setSupplierLedger] = useState([]);

  const table = useTable({
    defaultRowsPerPage: 10,
    defaultDense: false,
    defaultOrder: 'desc',
    defaultOrderBy: 'invoice_date',
    defaultSelected: [],
    defaultCurrentPage: 0,
  });

  const [supplier, setSupplier] = useState({
    company: '',
    accoundNo: '',
    phone: '',
    startDate: '',
    endDate: '',
  });
  const [nodataRow, setNodataRow] = useState('');

  const searchFormData = () => {
    let startDate = dates[0] ? format(dates[0], 'MM/dd/yyyy') : '';
    let endDate = dates[1] ? format(dates[1], 'MM/dd/yyyy') : '';
    setReportrange(startDate ? startDate + ' - ' + endDate : '');

    let supplierId = supplierValue ? supplierValue.value : '';

    if (!supplierId) {
      toast.error('Please select supplier');
      return;
    }
    loadSupplierLadger(supplierId, startDate, endDate);
  };

  const loadSupplierLadger = async (supplierId, startDate, endDate) => {
    try {
      const data = await AccountService.fetchSupplierLadger(supplierId, startDate, endDate, accessToken,token);

      if (Array.isArray(data) && data.length === 0) {
        setSupplier({ company: '', accoundNo: '', phone: '', startDate: '', endDate: '' });
        setSupplierLedger([]);
        setNodataRow('showinfo');
        table.onChangePage(null, 0);
        return;
      }
      if (data.supplier.company) {
        setSupplier({
          company: data.supplier.company,
          accoundNo: data.supplier.accound_no,
          phone: data.supplier.phone,
          startDate: data.start_date,
          endDate: data.end_date,
        });
        setSupplierLedger(data.supplier_ledger);
        setNodataRow('');
        table.onChangePage(null, 0);
      }
    } catch (error) {
      toast.error('Failed to load supplier ledger');
    }
  };

  const fetchSupplierList = async () => {
    const apiSalesRouteUrl = `${API_URL}/purchases/getSupplier`;
    try {
      const response = await fetch(apiSalesRouteUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const formattedOptions = data.supplier.map((item) => ({
        label: item.company,
        value: item.id,
      }));
      setSupplierOptions(formattedOptions);
    } catch (error) {
      toast.error('Failed to fetch supplier list');
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = BASE_URL;
      return;
    }
    fetchSupplierList();

    document.title = 'Supplier Ledger';
    return () => {
      document.title = 'Ebusso';
    };
  }, []);

  const renderRow = (item) => {
    const {
      id,
      invoice_date,
      payment_type,
      amount,
      balance,
      payment_status,
      reference_no,
      grn_id,
      particulars,
      paid_by,
    } = item;

    const formattedAmount = parseFloat(amount).toFixed(2);
    const formattedBalance = parseFloat(balance).toFixed(2);
    const name1 = payment_type === 'c' ? '' : (
      <a href={`./purchases/view_grn/${grn_id}`} style={{ color: "#212b36", textDecoration: "underline" }}>
        {reference_no}
      </a>
    );

    let particular1 = payment_type === 'c' ? 'Pay' : 'Inv';
    let status = '';

    if (payment_type !== 'c') {
      status = payment_status === 'Paid' ? 'Paid' : payment_status === 'Due' || payment_status === 'pending' ? 'UnPaid' : 'Partial';
    }

    return (
      <TableRow
        key={id}
        sx={{
          backgroundColor: particular1 === "Pay" ? "#b1edb1" : "transparent",
          "&:hover": {
            backgroundColor: particular1 === "Pay" ? "#a0dd9f" : "rgba(145, 158, 171, 0.04)",
          },
        }}
        className="table-cell-style"
      >
        <TableCell >{invoice_date}</TableCell>
        <TableCell >{name1}</TableCell>
        <TableCell>{payment_type !== "c" ? status : ""}</TableCell>
        <TableCell >{particular1}</TableCell>
        <TableCell align="right">
          {formattedAmount}
        </TableCell>
        <TableCell align="right">
          {formattedBalance}
        </TableCell>
      </TableRow>
    );
  };

  const [showModal, setShowModal] = useState(false);
  const [payDate, setPayDate] = useState(moment());
  const [paymentType, setPaymentType] = useState('');
  const [chequeNo, setChequeNo] = useState('');
  const [payAmount, setPayAmount] = useState('');
  const [reference, setReference] = useState('');
  const [isChequeVisible, setChequeVisible] = useState(false);

  const handlePaymentTypeChange = (e) => {
    const selectedType = e.target.value;
    setPaymentType(selectedType);
    setChequeVisible(selectedType === 'Cheque');
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setPayDate(moment());
    setPaymentType('');
    setChequeNo('');
    setPayAmount('');
    setReference('');
    setChequeVisible(false);
  };

  const handleSubmitPayment = () => {
    handleCloseModal();
  };

  const handlePrint = () => {
    if (!supplier.company || supplierLedger.length === 0) {
      toast.error('Please load supplier ledger data first');
      return;
    }

    const printWindow = window.open('', '', 'height=800,width=1200');
    const printContent = `
      <html>
        <head>
          <title>Supplier Ledger - ${supplier.company}</title>
          <style>
            @media print {
              @page {
                margin: 10mm;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
              font-size: 12px;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
            }
            .header h2 {
              margin: 0 0 10px 0;
              font-size: 18px;
            }
            .supplier-info {
              margin-bottom: 20px;
              padding: 10px;
              border: 1px solid #ddd;
            }
            .supplier-info p {
              margin: 5px 0;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f5f7fa;
              font-weight: 600;
              font-size: 11px;
            }
            td {
              font-size: 11px;
            }
            .text-right {
              text-align: right;
            }
            .payment-row {
              background-color: #b1edb1 !important;
            }
            .no-print {
              display: none;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>Supplier Ledger</h2>
          </div>
          <div class="supplier-info">
            <p><strong>Supplier:</strong> ${supplier.company}</p>
            <p><strong>Account No:</strong> ${supplier.accoundNo}</p>
            <p><strong>Phone:</strong> ${supplier.phone}</p>
            <p><strong>Period:</strong> ${supplier.startDate} to ${supplier.endDate}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Inv No</th>
                <th>Status</th>
                <th>Type</th>
                <th class="text-right">Amount</th>
                <th class="text-right">Balance</th>
              </tr>
            </thead>
            <tbody>
              ${supplierLedger.map((item) => {
      const formattedAmount = parseFloat(item.amount).toFixed(2);
      const formattedBalance = parseFloat(item.balance).toFixed(2);
      const particular1 = item.payment_type === 'c' ? 'Pay' : 'Inv';
      let status = '';
      if (item.payment_type !== 'c') {
        status = item.payment_status === 'Paid' ? 'Paid' : item.payment_status === 'Due' || item.payment_status === 'pending' ? 'UnPaid' : 'Partial';
      }
      const rowClass = particular1 === 'Pay' ? 'payment-row' : '';
      return `
                  <tr class="${rowClass}">
                    <td>${item.invoice_date}</td>
                    <td>${item.payment_type === 'c' ? '' : item.reference_no}</td>
                    <td>${status}</td>
                    <td>${particular1}</td>
                    <td class="text-right">${formattedAmount}</td>
                    <td class="text-right">${formattedBalance}</td>
                  </tr>
                `;
    }).join('')}
            </tbody>
          </table>
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
      </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
  };

  return (
    <>
      <Box className="page-container">
        <Paper
          elevation={0}
          className="paper-style"
        >
          <Box sx={{ px: 2, py: 1.2 }}>
            <Grid2 container spacing={2} display="flex" justifyContent="space-between" alignItems="center">
              <Grid2 size={{ xs: 12, md: 3 }}>
                <Typography className="page-title">
                  Supplier Ledger
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 3 }}>
                <Autocomplete
                  options={supplierOptions}
                  value={supplierValue}
                  onChange={(event, newValue) => {
                    setSupplierValue(newValue);
                  }}
                  getOptionLabel={(option) => option.label || ''}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="input-border"
                      placeholder="Select Supplier"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f7fa",
                          fontSize: "0.875rem",
                          "&:hover": {
                            backgroundColor: "#fff"
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#fff"
                          }
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "0.875rem",
                        },
                      }}
                    />
                  )}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f5f7fa",
                      fontSize: "0.875rem",
                      "&:hover": {
                        backgroundColor: "#fff"
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#fff"
                      }
                    },
                  }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 3 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <CommonDatePicker
                  className="input-border"
                  value={dates}
                  onChange={setDates}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 3 }} display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={1}>
                <Button
                  variant="contained"
                  className="button-variant-contained"
                  onClick={searchFormData}
                  sx={{ width: { xs: '100%', md: 'auto' } }}
                >
                  Submit
                </Button>
                {supplier.company && (
                  <Stack direction={{xs: 'column', md: 'row'}} spacing={1}>
                    <Button
                      variant="contained"
                      startIcon={<Iconify icon="eva:plus-fill" width={16} />}
                      onClick={handleOpenModal}
                      className="button-variant-contained"
                      sx={{ width: { xs: '100%', md: 'auto' } }}
                    >
                      Add Payment
                    </Button>
                    <Button
                      variant="outlined"
                      className="button-variant-outlined"
                      startIcon={<Iconify icon="eva:printer-fill" width={16} />}
                      onClick={handlePrint}
                      sx={{ width: { xs: '100%', md: 'auto' } }}
                    >
                      Print
                    </Button>
                  </Stack>
                )}
              </Grid2>
            </Grid2>

            {supplier.company && (
              <Box sx={{ my: 2 }}>
                <Paper
                  elevation={0}
                  sx={{
                    border: "1px solid rgba(145, 158, 171, 0.16)",
                    borderRadius: 1,
                    p: 2,
                  }}
                >
                  <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                      <Typography variant="body2" sx={{ fontSize: "0.875rem", color: "#212b36" }}>
                        <strong>Period From:</strong> {supplier.startDate} <strong>To:</strong> {supplier.endDate}
                      </Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                      <Typography variant="body2" sx={{ fontSize: "0.875rem", fontWeight: 800, color: "#212b36" }}>
                        {supplier.company}
                      </Typography>
                    </Grid2>
                  </Grid2>
                </Paper>
              </Box>
            )}

            {supplierLedger.length > 0 && (
              <TableContainer
           
              >
                <Table
                  size="small"
                  className="table-cell-border"
                >
                  <TableHead
                  >
                    <TableRow className="table-cell-header" >
                      <TableCell width="150px">
                        Date
                      </TableCell>
                      <TableCell width="150px">
                        Inv No
                      </TableCell>
                      <TableCell width="150px">
                        Status
                      </TableCell>
                      <TableCell width="150px">
                        Type
                      </TableCell>
                      <TableCell
                        width="150px"
                        align="right"

                      >
                        Amount
                      </TableCell>
                      <TableCell
                        width="150px"
                        align="right"
                      >
                        Balance
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {supplierLedger
                      .slice(table.page * table.rowsPerPage, table.page * table.rowsPerPage + table.rowsPerPage)
                      .map((item) => renderRow(item))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {supplierLedger.length > 0 && (
              <Box sx={{ pt: 2 }}>
                <TablePaginationCustom
                  className="pagination-styles"
                  page={table.page}
                  dense={table.dense}
                  count={supplierLedger.length}
                  rowsPerPage={table.rowsPerPage}
                  onPageChange={table.onChangePage}
                  onRowsPerPageChange={table.onChangeRowsPerPage}
                />
              </Box>
            )}

            {nodataRow && (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography variant="body2" sx={{ color: "#d32f2f", fontSize: "0.875rem" }}>
                  NO Transaction Available.
                </Typography>
              </Box>
            )}
          </Box>
        </Paper>
      </Box>
      <Dialog open={showModal} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>Add Payment</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <DatePicker               
                    label="Date"
                    value={payDate}
                    onChange={(date) => setPayDate(date)}
                    format="DD-MM-YYYY"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#f5f7fa",
                            fontSize: "0.875rem",
                            "&:hover": {
                              backgroundColor: "#fff"
                            },
                            "&.Mui-focused": {
                              backgroundColor: "#fff"
                            }
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: "0.875rem",
                          },
                        },
                      },
                    }}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ fontSize: "0.875rem" }}>Paying by *</InputLabel>
                    <Select      
                      value={paymentType}
                      label="Paying by *"
                      onChange={handlePaymentTypeChange}
                      sx={{
                        fontSize: "0.875rem",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f7fa",
                          fontSize: "0.875rem",
                          "&:hover": {
                            backgroundColor: "#fff"
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#fff"
                          }
                        },
                        "& .MuiSelect-select": {
                          fontSize: "0.875rem",
                        },
                      }}
                    >
                      <MenuItem value="" sx={{ fontSize: "0.875rem" }}>Select Type</MenuItem>
                      <MenuItem value="cash" sx={{ fontSize: "0.875rem" }}>Cash</MenuItem>
                      <MenuItem value="CC" sx={{ fontSize: "0.875rem" }}>Credit Card</MenuItem>
                      <MenuItem value="Cheque" sx={{ fontSize: "0.875rem" }}>Cheque</MenuItem>
                    </Select>
                  </FormControl>
                </Grid2>
                {isChequeVisible && (
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <TextField
                      fullWidth
              
                      label="Cheque No"
                      value={chequeNo}
                      onChange={(e) => setChequeNo(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f7fa",
                          fontSize: "0.875rem",
                          "&:hover": {
                            backgroundColor: "#fff"
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#fff"
                          }
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "0.875rem",
                        },
                      }}
                    />
                  </Grid2>
                )}
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <TextField
                    fullWidth
                    label="Amount"
                    type="number"
                    value={payAmount}
                    onChange={(e) => setPayAmount(e.target.value)}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f5f7fa",
                        fontSize: "0.875rem",
                        "&:hover": {
                          backgroundColor: "#fff"
                        },
                        "&.Mui-focused": {
                          backgroundColor: "#fff"
                        }
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                      },
                    }}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <TextField
                    fullWidth
                    label="Reference"
                    value={reference}
                    onChange={(e) => setReference(e.target.value)}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f5f7fa",
                        fontSize: "0.875rem",
                        "&:hover": {
                          backgroundColor: "#fff"
                        },
                        "&.Mui-focused": {
                          backgroundColor: "#fff"
                        }
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                      },
                    }}
                  />
                </Grid2>
              </Grid2>
            </LocalizationProvider>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} className="button-variant-outlined" variant="outlined">
            Close
          </Button>
          <Button onClick={handleSubmitPayment}
            className="button-variant-contained"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SupplierLedger;
